<template>
  <v-sheet color="transparent">
    <Events></Events>
  </v-sheet>
</template>

<script>
  import Events from '@/components/Management/Events'
  export default {
    name: 'Management',
    components: {
      Events,
    },
  }
</script>
